// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__y2vy3","card":"NotFound_card__-S3e2","code":"NotFound_code__7APch","btn":"NotFound_btn__i6AKB"};